import React from 'react';
import PropTypes from 'prop-types';
import { Card, Button, Message } from 'semantic-ui-react';
import StoryCard from './StoryCard';
import StoriesSkeleton from './StoriesSkeleton';

const styles = {
  empty: { textAlign: 'center', color: 'grey', padding: '2em' },
  footer: { textAlign: 'center', marginTop: '1.5em' },
  endText: { color: 'grey', fontSize: '85%' },
};

// One platform's page(s): error / skeleton / empty / grid + "Load more".
const StoriesGrid = ({
  stories, loading, error, cursor, onLoadMore, added, adding, onAddStory,
}) => {
  if (error) return <Message negative content={`Couldn't load stories: ${error}`} />;
  if (loading && stories.length === 0) return <StoriesSkeleton />;
  if (!loading && stories.length === 0) return <div style={styles.empty}>No stories match these filters.</div>;

  return (
    <div>
      <Card.Group itemsPerRow={4} doubling stackable>
        { stories.map(story => (
          <StoryCard
            key={`${story.platform}-${story.id}`}
            story={story}
            added={!!added[story.assetId]}
            adding={!!adding[story.assetId]}
            onAdd={() => onAddStory(story)}
          />
        )) }
      </Card.Group>
      <div style={styles.footer}>
        { cursor
          ? <Button loading={loading} disabled={loading} onClick={onLoadMore}>Load more</Button>
          : <span style={styles.endText}>End of results</span>
        }
      </div>
    </div>
  );
};

StoriesGrid.propTypes = {
  stories: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.string,
  cursor: PropTypes.string,
  onLoadMore: PropTypes.func.isRequired,
  added: PropTypes.object.isRequired,
  adding: PropTypes.object.isRequired,
  onAddStory: PropTypes.func.isRequired,
};

StoriesGrid.defaultProps = {
  error: null,
  cursor: null,
};

export default StoriesGrid;



/** WEBPACK FOOTER **
 ** ./src/components/all-stories-modal/StoriesGrid.js
 **/